import './message/message';
import './trace/trace';

import cookie from './cookie/cookie';
import * as layer from './layer/layer';
import Player from './player/player';
import Preloader from './preloader/preloader';
import Cnb from './cnb/cnb';
import Comment from './comment/comment';
import share from './share/js/share';
import remote from './remote/remote';

export default {
    Cnb,
    Comment,
    cookie,
    ...layer,
    Player,
    Preloader,
    share,
    remote
}